import { server } from './config'
import client from './client'

export default {
  
  connectProperty(data = {}, config = {}) {
    return client.get(`${server}/payment/api/connect?property=${data}`)
  },

  getCountryList(language) {
    return client.get(`${server}/payment/api/countries?language=${language}`)
  },
}
